export interface TypeAndRiskInterface {
  title: string;
  value: number;
}

export const RELEASE_TYPE_LIST: TypeAndRiskInterface[] = [
  {title: 'Patch', value: 0},
  {title: 'Minor', value: 1},
  {title: 'Major', value: 2}
];

export const RISK_LEVEL_LIST: TypeAndRiskInterface[] = [
  {title: 'Low', value: 0},
  {title: 'Medium', value: 1},
  {title: 'High', value: 2}
];

export interface ReleaseFormSubmitInterface {
  description: string;
  name: string;
  riskLevel: number;
  targetReleaseDate: number;
  type: number;
}
